var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeWallet = function SvgHomeWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M15.5 5.125h.5a.5.5 0 0 0-.5-.5zm0 3.75v.5a.5.5 0 0 0 .5-.5zM11.75 6.5a.5.5 0 0 0 0 1zm.008 1a.5.5 0 0 0 0-1zM2 1.5h12v-1H2zm13 1v9h1v-9zm-1 10H2v1h12zm-13-1v-9H0v9zm1 1a1 1 0 0 1-1-1H0a2 2 0 0 0 2 2zm13-1a1 1 0 0 1-1 1v1a2 2 0 0 0 2-2zm-1-10a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2zM2 .5a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1zm9.375 5.125H15.5v-1h-4.125zm3.625-.5v3.75h1v-3.75zm.5 3.25h-4.125v1H15.5zm-4.125 0C10.615 8.375 10 7.759 10 7H9a2.375 2.375 0 0 0 2.375 2.375zm0-3.75A2.375 2.375 0 0 0 9 7h1c0-.76.616-1.375 1.375-1.375zM11.75 7.5h.008v-1h-.008z"
  })));
};
export default SvgHomeWallet;